import React from "react";
import {observer} from "mobx-react";
import {
    IPsoFamilyAgreementViewModel,
} from "../../../../../../services/booking/models/pso/agreements/families/pso-family-agreement.view-model.interface";
import {FullGridLineBox} from "../../../common/boxes/pso-agreement.boxes";
import {StringFieldEditorComponent} from "../../../../../forms/string-field/string-field-editor.component";

export const FirstToThirdDegreeOfKinshipDescriptionComponent: React.FC<{familyAgreement: IPsoFamilyAgreementViewModel}> = observer((props) => {

    if(props.familyAgreement.fields.degreeOfKinshipType.isHidden) {
        return null;
    }

    return (
        <FullGridLineBox>
            <StringFieldEditorComponent field={props.familyAgreement.fields.degreeOfKinshipDescription}
                                        placeholder={props.familyAgreement.fields.degreeOfKinshipDescription.fieldName}
                                        hideLabel={true}/>
        </FullGridLineBox>
    )
})